import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import React, { isValidElement } from 'react';
import { EyeOff, Eye } from 'react-feather';
import { useUncontrolled } from '../../hooks/useUncontrolled.js';
import defaultStyles from './styles/InputPassword.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { Input } from '../input/Input.js';
import { omit } from '../../utils/omit.js';
import { Button } from '../button/Button.js';

const ID_SUFFIX = '_input_password';
const InputPassword = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme,
    visibilityToggle = true,
    onVisibilityChange,
    name = 'password',
    suffix,
    idSuffix = ID_SUFFIX,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [visible, handleChange] = useUncontrolled({
    value: props.visibility,
    defaultValue: props.defaultVisibility,
    onChange: onVisibilityChange
  });
  let icon = null;
  if (visibilityToggle) {
    const actionProps = {
      onClick: () => handleChange(!visible),
      onMouseDown: e => e.preventDefault(),
      onMouseUp: e => e.preventDefault()
    };
    if ( /*#__PURE__*/isValidElement(suffix)) {
      icon = suffix;
    } else {
      const IconComponent = visible ? EyeOff : Eye;
      icon = /*#__PURE__*/jsx(Button, {
        title: visible ? 'Hide Password' : 'Show Password',
        flat: true,
        shape: "circle",
        status: "secondary",
        variant: "ghost",
        size: "xs",
        ...actionProps,
        children: /*#__PURE__*/jsx(IconComponent, {})
      });
    }
  }
  return /*#__PURE__*/jsx(Input, {
    ...omit(rest, ['visibility', 'defaultVisibility']),
    type: visible ? 'text' : 'password',
    theme: {
      holder: styles.password,
      ...styles
    },
    ref: ref,
    suffix: icon,
    name: name,
    idSuffix: idSuffix
  });
});
InputPassword.displayName = 'InputPassword';

export { InputPassword };
